import { usePageMeta } from "../hooks/usePageMeta";
import { PageHero } from "../components/PageHero";
import { CONTACT } from "../data/site";

const sections = [
  {
    title: "1. Titolare del trattamento",
    body: "Il titolare del trattamento dei dati personali è Costruzioni Ciosko di Cheloski Erhan, con sede in Via Pietro Valentini, 4 int. — 31056 Roncade (TV), C.F. CHLRHN90R28Z148F. Per qualsiasi informazione è possibile scrivere a costruzioniciosko@gmail.com.",
  },
  {
    title: "2. Dati raccolti",
    body: "Attraverso il modulo di contatto raccogliamo i dati forniti volontariamente dall'utente: nome e cognome, eventuale azienda, telefono, email, località, tipo di intervento richiesto, messaggio ed eventuali fotografie o documenti allegati. Durante la navigazione possono essere raccolti dati tecnici e di utilizzo in forma aggregata e anonima.",
  },
  {
    title: "3. Finalità e base giuridica",
    body: "I dati forniti tramite il modulo di contatto sono trattati esclusivamente per rispondere alla richiesta di preventivo o di informazioni inviata dall'utente (art. 6, par. 1, lett. b del GDPR). Il consenso al trattamento viene richiesto espressamente prima dell'invio del modulo.",
  },
  {
    title: "4. Modalità del trattamento e conservazione",
    body: "Il trattamento avviene con strumenti informatici, nel rispetto delle misure di sicurezza previste dall'art. 32 del GDPR. I dati sono conservati per il tempo necessario a gestire la richiesta e gli eventuali adempimenti contrattuali e fiscali conseguenti.",
  },
  {
    title: "5. Comunicazione a terzi",
    body: "I dati non vengono venduti né ceduti a terzi. Possono essere trattati da fornitori tecnici (hosting, servizi email) che operano nel rispetto del GDPR in qualità di responsabili del trattamento.",
  },
  {
    title: "6. Diritti dell'interessato",
    body: `In qualità di interessato puoi esercitare i diritti previsti dagli artt. 15-22 del GDPR (accesso, rettifica, cancellazione, limitazione, portabilità, opposizione) scrivendo a ${CONTACT.email}. Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali.`,
  },
  {
    title: "7. Aggiornamenti",
    body: "La presente informativa può essere aggiornata nel tempo. Ultimo aggiornamento: luglio 2026.",
  },
];

export default function Privacy() {
  usePageMeta(
    "Privacy Policy | Costruzioni Ciosko",
    "Informativa privacy di Costruzioni Ciosko: come trattiamo i dati personali raccolti tramite il sito e il modulo di contatto, ai sensi del GDPR."
  );
  return (
    <>
      <PageHero overline="Documenti" lines={["Privacy Policy"]} description="Informativa sul trattamento dei dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR)." />
      <section className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-5 lg:px-10 space-y-10">
          {sections.map((s) => (
            <article key={s.title}>
              <h2 className="font-display font-bold text-lg sm:text-xl text-white tracking-tight">{s.title}</h2>
              <p className="text-cement text-sm sm:text-[15px] leading-relaxed mt-3">{s.body}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
